<section class="testimonials-section">
  <div class="container">
    <div class="section-header">
      <span class="section-badge">Témoignages</span>
      <h2>Ils ont franchi le pas</h2>
      <p>Découvrez comment des experts-comptables ont transformé leur pratique avec Wealthlane</p>
    </div>
    <div class="testimonials-grid">
      <div class="testimonial-card">
        <div class="testimonial-quote">
          <img src="/images/landing/quote.svg" alt="Quote" />
        </div>
        <p class="testimonial-text">"Wealthlane nous a permis de facturer 32 000€ de missions patrimoniales supplémentaires la première année. Les revenus ont été immédiats."</p>
        <div class="testimonial-author">
          <div class="author-avatar">MC</div>
          <div class="author-info">
            <div class="author-name">Marc Collin</div>
            <div class="author-title">Expert-Comptable, Paris</div>
          </div>
        </div>
      </div>

      <div class="testimonial-card">
        <div class="testimonial-quote">
          <img src="/images/landing/quote.svg" alt="Quote" />
        </div>
        <p class="testimonial-text">"L'outil génère en 5 minutes ce qui me prenait une journée. Je peux enfin proposer du conseil patrimonial à tous mes clients dirigeants."</p>
        <div class="testimonial-author">
          <div class="author-avatar">SL</div>
          <div class="author-info">
            <div class="author-name">Sophie Laurent</div>
            <div class="author-title">Cabinet Expertise Plus, Lyon</div>
          </div>
        </div>
      </div>

      <div class="testimonial-card">
        <div class="testimonial-quote">
          <img src="/images/landing/quote.svg" alt="Quote" />
        </div>
        <p class="testimonial-text">"Mes clients apprécient d'avoir une vision globale : comptabilité + patrimoine. Ça renforce considérablement notre relation de confiance."</p>
        <div class="testimonial-author">
          <div class="author-avatar">JD</div>
          <div class="author-info">
            <div class="author-name">Jean Dupont</div>
            <div class="author-title">Expert-Comptable, Bordeaux</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

